<div class="dialog-loading" *ngIf="(loading$ | async)">
    <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
    <div class="dialog-title">{{data.act?.name}}</div>
    <div class="dialog-close" (click)="closeDialog(false)">
        <mat-icon>close</mat-icon>
    </div>
</div>
<div class="dialog-content scrollable">
    <div class="scroll-content-padding dialog-form df-c gap20">
        <div class="df ai-c gap10" *ngIf="data.act.reversed || data.act.custom || data.act.taxInvoiceRegistered">
            <span class="doc-badge custom" *ngIf="data.act.custom">Довільний</span>
            <span class="doc-badge reversed" *ngIf="data.act.reversed">Сторновано</span>
            <span class="doc-badge tax" *ngIf="data.act.taxInvoiceRegistered">
                ПН № {{data.act.taxInvoiceNumber}} від {{data.act.taxInvoiceDate | date: 'dd.MM.yyyy'}}
            </span>
        </div>

        <div class="key-value grid gap10">
            <span class="key">Від компанії</span>
            <span class="value">{{data.act?.dahCounterParty?.name ? data.act.dahCounterParty?.name : ''}}</span>

            <span class="key">Договір</span>
            <span class="value">{{data.act?.contract?.name ? data.act.contract?.name : ''}}</span>

            <span class="key">Дата</span>
            <span class="value">{{data.act.date | date: 'dd.MM.yyyy HH:mm'}}</span>

            <span class="key">Період</span>
            <span class="value">{{data.act.period}}</span>

            <span class="key">Номер</span>
            <span class="value">{{data.act.number}}</span>

            <span class="key">Сума</span>
            <span class="value df gap10">
                <span>{{data.act.amount | currency:'UAH': 'грн.':'0.2-2'}}</span>
                <button class="item-action-button gray" *ngIf="!data.act.reversed"
                        (click)="amount.setValue(data.act.amount); comment.setValue(data.act.comment); amountEdit = true">
                    <mat-icon>edit</mat-icon>
                </button>
                <button class="item-action-button gray" [disabled]="!data.act.link" (click)="openLink()"
                        matTooltip="Переглянути файл акту" matTooltipClass="tooltip">
                    <mat-icon>link</mat-icon>
                </button>
            </span>

            <ng-container *ngIf="data.act.uncovered">
                <span class="key">Незакрито платежем</span>
                <span class="value warning">{{data.act.uncovered | currency:'UAH': 'грн.':'0.2-2'}}</span>
            </ng-container>

            <span class="key">Підписи</span>
            <span class="value">
                <span *ngIf="data.act.signType == 'MANUALLY_SIGNED'">Підписано власноруч</span>
                <span class="df gap20 jc-s ai-c" *ngIf="data.act.signType != 'MANUALLY_SIGNED'">
                    <span class="file-sign">
                        <span class="bold">Дах КЕП:</span>
                        <span [ngClass]="data.act.signersDah?.length ? 'signed' : 'not-signed'">
                            {{data.act.signersDah?.length ? 'Підписано' : 'Не підписано'}}
                        </span>
                    </span>
                    <span class="file-sign">
                        <span class="bold">Клієнт КЕП:</span>
                        <span [ngClass]="data.act.signersClient?.length ? 'signed' : 'not-signed'">
                            {{data.act.signersClient?.length ? 'Підписано' : 'Не підписано'}}
                        </span>
                    </span>
                </span>
            </span>
        </div>

        <div *ngIf="amountEdit" class="df gap10 jc-s ai-c">
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px; max-width: 120px">
                <mat-label>{{'modules.billing.agreements.agreementDialog.labels.amount' | translate}}</mat-label>
                <input type="number" matInput [formControl]="amount" step=".01">
            </mat-form-field>
            <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width grow">
                <mat-label>Коментар</mat-label>
                <input type="text" matInput [formControl]="comment">
            </mat-form-field>
            <span class="add-row" (click)="submitForm(false)">Зберегти</span>
            <span class="cancel" (click)="closeEditAmount()">Відмінити</span>
        </div>

        <div class="key-value grid gap10" *ngIf="data.act.comment && !amountEdit">
            <span class="key">Коментар</span>
            <span class="value">{{data.act.comment}}</span>
        </div>
    </div>
</div>
<div class="buttons-row df jc-e ai-c gap20">
    <button class="default-button apply-button" (click)="closeDialog(false)">
        {{'common.buttons.close' | translate}}
    </button>
</div>
